export default __webpack_public_path__ + "static/media/IBEW-Sep2022-exhibit-img.6c139fee.png";